module.exports = __webpack_public_path__ + "img/product_132.901d4b8.webp";